import moment from "moment";

export const numberFormatter = (
  num: number | string,
  opts: Intl.NumberFormatOptions = { maximumFractionDigits: 12 }
) => {
  const lang = moment.locale();
  const number = Number(num);

  if (isNaN(number)) return "N/A";
  return num !== undefined && num !== null
    ? number.toLocaleString(lang === "vi" ? "vi-VN" : "en-US", opts)
    : "N/A";
};

export const numberFromLocaleString = (str: string) => {
  return str.replace(/,|./gi, "");
};

export const dateTimeFormatter = (
  date: string | number,
  fallback: string = ""
) => {
  if (!date) return fallback;
  const lang = moment.locale();
  return new Date(date).toLocaleString(lang === "vi" ? "vi-VN" : "en-US");
};

export const dateFormatter = (date: string | number, fallback: string = "") => {
  if (!date) return fallback;
  const lang = moment.locale();
  return new Date(date).toLocaleDateString(lang === "vi" ? "vi-VN" : "en-US");
};

export const formatDateDefault = (date, pattern = "MM/DD/YYYY") => {
  return moment(date).format(pattern);
};
